import * as searchSetters from './store/searchStore-setters'
import * as dateFiltersGetters from './store/date-filters-getters'
import * as searchModule from './search'
// get default data from config file
import configData from '../../config'

const onload = () => {
  // first loads data
  searchSetters.setNewSorting(configData().params.search.default.sortOptionAll)

  if (dateFiltersGetters.getDateTo() != '' && dateFiltersGetters.getDateFrom() != '') {
    searchModule.loadResultsWithDataPreloadAlt()
  } else {
    searchModule.loadResultsWithDataPreload()
  }
}

export {
  onload
}



// WEBPACK FOOTER //
// ./src/scripts/modules/main-page.js